import axios from "axios";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Rating from "@mui/material/Rating";
import Typography from "@mui/material/Typography";
import { baseURL, getComments } from "../redux/Action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddComment = ({ id }) => {
  const { user, isAuth, token } = useSelector((state) => state);
  const navigate = useNavigate();

  const [message, setMessage] = useState({
    message: "",
  });
  const [value, setValue] = React.useState(2);

  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMessage({
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isAuth) {
      return navigate("/login");
    }
    const payload = {
      user_id: user.user._id,
      blog_id: id,
      ...message,
      rating: value,
      parentId: id,
    };
    const toastId = toast.loading("Commenting...", { theme: "dark" });
    axios
      .post(`${baseURL}/comments`, payload, {
        withCredentials: true,
        headers: {
          Authorization: token,
        },
      })
      .then((res) => {
        toast.update(toastId, {
          render: "Commented",
          type: "success",
          isLoading: false,
          theme: "dark",
          autoClose: 2000,
          closeOnClick: true,
        });
        getComments(dispatch, id);
        setMessage({ message: "" });
      })
      .catch((err) => {
        toast.update(toastId, {
          render: "Something went wrong",
          type: "error",
          isLoading: false,
          autoClose: 2000,
          closeOnClick: true,
        });
      });
  };
  return (
    <>
      <form
        onSubmit={handleSubmit}
        className="mt-6 shadow-md border border-slate-200 dark:border-none dark:bg-[#1d1e2b] rounded px-4 py-4 lg:w-[500px]"
      >
        <textarea
          name="message"
          id="message"
          cols="60"
          placeholder="what are your thoughts?"
          className="resize-horizontal outline-none w-full dark:bg-[#2e2f44] dark:text-white px-2 py-2"
          value={message.message}
          onChange={handleChange}
          required
        ></textarea>
        <Box
          sx={{
            "& > legend": { mt: 2 },
          }}
        >
          <Typography component="legend" className="dark:text-white">
            Rate Blog
          </Typography>
          <Rating
            name="simple-controlled"
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          />
        </Box>
        <div>
          <button className="flex mx-2 my-2 text-white bg-[#1D4ED8] border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600  rounded text-sm ">
            Respond
          </button>
        </div>
      </form>
    </>
  );
};

export default AddComment;
